/**
 * @generated SignedSource<<eff3080ef5e81c5df1ae5537862c6380>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type bambooDuplicatesRefetchQuery$variables = {};
export type bambooDuplicatesRefetchQuery$data = {
  readonly viewer: {
    readonly " $fragmentSpreads": FragmentRefs<"bambooDuplicates_viewer">;
  } | null;
};
export type bambooDuplicatesRefetchQuery = {
  variables: bambooDuplicatesRefetchQuery$variables;
  response: bambooDuplicatesRefetchQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "bambooDuplicatesRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "bambooDuplicates_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "bambooDuplicatesRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "MissionControlDataType",
            "kind": "LinkedField",
            "name": "missionControlData",
            "plural": false,
            "selections": [
              (v0/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "MissionControlBambooDuplicatesType",
                "kind": "LinkedField",
                "name": "bambooDuplicates",
                "plural": true,
                "selections": [
                  (v0/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "company",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "duplicateCount",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "19411d3d3e59433a38ea507c95688903",
    "id": null,
    "metadata": {},
    "name": "bambooDuplicatesRefetchQuery",
    "operationKind": "query",
    "text": "query bambooDuplicatesRefetchQuery {\n  viewer {\n    ...bambooDuplicates_viewer\n    id\n  }\n}\n\nfragment bambooDuplicates_viewer on Viewer {\n  id\n  missionControlData {\n    id\n    bambooDuplicates {\n      id\n      company\n      duplicateCount\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "4eb4a80b53857259f635d674e43f0068";

export default node;
